/**
 * Calculates the days, hours, and minutes remaining between the current time
 * and the provided end time.
 */
export const calculateTimeRemaining = endDate => {
  const now = new Date().getTime();
  const end = new Date(endDate).getTime();
  const difference = end - now;
  if (difference <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0
    };
  }
  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
  return {
    days,
    hours,
    minutes
  };
};

/**
 * Formats a time unit (days, hours, minutes) to a two-digit string.
 */
export const formatTimeUnit = value => value.toString().padStart(2, '0');